export default __webpack_public_path__ + "static/pay-banner-3-d3c3a6167fc589803801e4989081ca9f.jpeg";